import { ControlBarButtonStyles, MicrophoneButton, usePropsFor, useTheme } from '@azure/communication-react';
import React, { useCallback } from 'react';
import { MicrophoneIconOff, MicrophoneIconOn } from '../Icons';

interface ControlBarMicrophoneButtonProps {
    styles?: ControlBarButtonStyles;
    disabled?: boolean;
}

export const ControlBarMicrophoneButton = (props: ControlBarMicrophoneButtonProps) => {
  const microphoneProps = usePropsFor(MicrophoneButton);
  const disabled = microphoneProps.disabled || props.disabled;
  const themeV8 = useTheme();

  //TODO: remove "width: 24, height: 24," from "svgIconStyle". 
  /*
    <ControlButtonMicOn> component is mapped to 'Mic20Filled' icon in the '@fluentui/react-components' lib:
      const DEFAULT_COMPONENT_ICONS = {
        ...
        ControlButtonMicOn: <Mic20Filled />,
      }

    In order to prevent style rewrite, it would be better somehow to use 'Mic24Filled' icon instead of 'Mic20Filled' in the live-lesson project.
  */
  const onIconOn = useCallback(() => (
    <MicrophoneIconOn disabled={disabled === true}/>
  ), [disabled, themeV8]);

  const onIconOff = useCallback(() => (
    <MicrophoneIconOff disabled={disabled === true}/>
  ), [disabled, themeV8]);

  return (microphoneProps &&
    <MicrophoneButton
      {...microphoneProps}
      disabled={disabled}
      onRenderOnIcon={onIconOn}
      onRenderOffIcon={onIconOff}
      showLabel={false}
      enableDeviceSelectionMenu={false}
      styles={props.styles}
  />)
}
